import { AnimatePresence, motion } from "framer-motion";
import { useTranslation } from "react-i18next";

import { formatCurrency } from "@/lib/intl";

export const timeAgo = (isoDate, t) => {
  const s = Math.max(0, (Date.now() - new Date(isoDate).getTime()) / 1000);
  if (s < 60) return t("common.justNow");
  if (s < 3600) return t("common.minutesAgo", { count: Math.floor(s / 60) });
  if (s < 86400) return t("common.hoursAgo", { count: Math.floor(s / 3600) });
  return t("common.daysAgo", { count: Math.floor(s / 86400) });
};

/** Live bid feed — paddle numbers only, never identities. */
export const BidHistory = ({ bids, currency, locale, myPaddle }) => {
  const { t } = useTranslation();
  if (!bids?.length) {
    return (
      <p className="text-sm text-[#737373] py-6 text-center" data-testid="bid-history-empty">
        {t("bid.noBidsYet")}
      </p>
    );
  }
  return (
    <ol className="flex flex-col divide-y divide-black/5" data-testid="bid-history">
      <AnimatePresence initial={false}>
        {bids.map((b, i) => {
          const mine = myPaddle != null && b.paddle === myPaddle;
          return (
            <motion.li
              key={`${b.created_at}-${b.paddle}-${b.amount_cents}`}
              initial={{ opacity: 0, y: -8 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
              className="flex items-center justify-between py-3 gap-3"
              data-testid={`bid-row-${i}`}
            >
              <div className="flex items-center gap-2.5 min-w-0">
                <span
                  className={`inline-flex items-center justify-center h-7 min-w-[3.5rem] px-2 rounded-full text-xs font-semibold ${
                    i === 0 ? "bg-[#1D4D3B] text-white" : "bg-black/5 text-[#0A0A0A]"
                  }`}
                >
                  #{b.paddle}
                </span>
                {mine && <span className="text-[10px] font-semibold uppercase tracking-wider text-[#1D4D3B]">{t("bid.you")}</span>}
                {b.kind === "proxy_auto" && (
                  <span className="text-[10px] font-semibold uppercase tracking-wider text-[#737373]">{t("bid.auto")}</span>
                )}
              </div>
              <div className="flex items-center gap-3 shrink-0">
                <span className="text-sm font-semibold tabular-nums text-[#0A0A0A]">
                  {formatCurrency(b.amount_cents, currency, locale)}
                </span>
                <span className="text-xs text-[#737373] tabular-nums whitespace-nowrap shrink-0 text-right">{timeAgo(b.created_at, t)}</span>
              </div>
            </motion.li>
          );
        })}
      </AnimatePresence>
    </ol>
  );
};
